<template>
  <div class="no-data-container">
    <img src="../../common/img/no-data.png" alt="">
    <div class="no-data-tips">{{ tips || '暂无数据' }}</div>
  </div>
</template>

<script>
export default {
  props: ['tips'],
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.no-data-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px;
  img{
    width: 200px;
  }
  .no-data-tips{
    color: #999;
    margin-top: 20px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/NoData.vue